import { render, staticRenderFns } from "./DeleteLesson.vue?vue&type=template&id=03bdefa8"
import script from "./DeleteLesson.vue?vue&type=script&lang=js"
export * from "./DeleteLesson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports